// extracted by mini-css-extract-plugin
export default {"bar":"MusicBar_bar__Tr4te","info":"MusicBar_info__2lJ7r","playArea":"MusicBar_playArea__a378r","music-button":"MusicBar_music-button__c6I04"};